import { useMantineTheme } from '@mantine/core';
import { IconFileDollar, IconPencil, IconTrash } from '@tabler/icons-react';
import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import styleIdentifiers from './RecoveryPlan.module.scss';
import type { RecoveryPlanStepLineProps } from './RecoveryPlanStep.types';
import { RecoveryPlanStepAICallLine } from './RecoveryPlanStepAICallLine';
import { RecoveryPlanStepTaskLine } from './RecoveryPlanStepTaskLine';

const styles = classNames.bind(styleIdentifiers);

export const RecoveryPlanStepLine = ({
  index,
  step,
  editMode,
  editStep,
  deleteStep,
}: RecoveryPlanStepLineProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const { step_type, invoices_count } = step;

  return (
    <div className={styles('step')}>
      {step_type === 'initiate_ai_call' ? (
        <RecoveryPlanStepAICallLine />
      ) : (
        <RecoveryPlanStepTaskLine index={index} step={step} />
      )}
      <div className={styles('line-action')}>
        {editMode && (
          <>
            <div className={styles('action', 'add')} onClick={editStep!(index)}>
              <IconPencil color={theme.colors.gray[6]} size={22} stroke={1.5} />
            </div>
            {step_type !== 'first_reminder' && deleteStep && (
              <div className={styles('action', 'red')} onClick={deleteStep(index)}>
                <IconTrash color={theme.colors.red[7]} size={22} stroke={1.5} />
              </div>
            )}
          </>
        )}
        <div
          className={styles('action', 'invoice')}
          title={t(i18nKeys.PLAN.INVOICES_EXECUTED_STEP)}
        >
          {invoices_count || 0}
          <IconFileDollar color={theme.colors.gray[6]} size={18} stroke={1.5} />
        </div>
      </div>
    </div>
  );
};
